import { Typography, Row, Col } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export const AboutPage = () => {
  
  return (
    <div>
      {/* Hero Section */}
      <section className="relative w-full h-[400px]">
        <div className="about-bg opacity-40 absolute inset-0 w-full h-full"></div>
        <div className="container relative h-full flex flex-col justify-center items-center mx-auto px-4 py-12 z-10">
          <Title level={1} className="font-android !font-normal text-yellow-principal text-center mt-14">
            ABOUT RUPPERT
          </Title>
          <div className="max-w-3xl mx-auto">
            <Paragraph className="font-barlow text-gray-300 text-center md:text-lg lg:!text-xl">
              Founded in 2005, Ruppert has become a leading name in construction and excavation services, 
              setting industry standards with our commitment to quality, integrity, and reliability.
            </Paragraph>
          </div>
        </div>
      </section>
      
      {/* Company Story */}
      <section className="w-full bg-first-dark-gray pt-8 pb-18">
        <div className="container mx-auto px-4">
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} md={12}>
              <Title level={2} className="font-android !font-normal text-yellow-principal mt-4">OUR STORY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                The company was founded in 2005 by three brothers, Josh, Nate and Tim Ruppert. And almost immediately began to take enough work to maintain 25 – 30 full time employees. They did a large variety of work including framing, excavation, commercial snow removal, interior and exterior remodels, defensible space, structural and ornamental steel fabrication and more.
              </Paragraph>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                As the company grew, it became more evident that it would be more effective to split the operations into two separate companies, Josh acquired a different
                contractor's license in 2015 and started Josh Ruppert Construction, most of the framing and general building construction went with him. And now most recently Josh has acquired the metal fabrication works, and operates that as a his structural steel division.
              </Paragraph>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                Nate and Tim mostly limited their operation of Ruppert, Inc to the general engineering and snow removal, with a few select residential general building
                projects included throughout the years. The maintenance and upkeep of the equipment consists of a 2 to 4 employee shop that does all the service and repairs
                in house as well and custom fabrication of truck bodies and equipment implements. Ruppert, Inc runs an average of 90 summer employees and 10 to 15 off season/winter employees.
              </Paragraph>
            </Col>
            <Col xs={24} md={12}>
              <div>
                <img 
                  src="/assets/images/ruppert-about.png" 
                  alt="Ruppert Excavator" 
                  className="w-full max-h-[400px] object-cover"
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      
      {/* Team Section */}
      <section className="w-full bg-second-black-carbon py-18">
        <div className="container text-center mx-auto px-4 pb-6">
          <Title level={2} className="font-android !font-normal text-yellow-principal text-center pb-8">OUR TEAM</Title>          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">            
            <div className="bg-zinc-800 h-30 p-8">
              <Title level={3} className="font-android !font-normal text-yellow-principal text-center !text-xl">NATE RUPPERT</Title>
              <div className="font-android !font-normal text-gray-300 text-sm mb-4">FOUNDER, CEO</div>
            </div>            
            <div className="bg-zinc-800 h-30 p-8">
              <Title level={3} className="font-android !font-normal text-yellow-principal text-center !text-xl">TIM RUPPERT</Title>
              <div className="font-android !font-normal text-gray-300 text-sm mb-4">CO-FOUNDER, BUSINESS MANAGER</div>
            </div>            
            <div className="bg-zinc-800 h-30 p-8">
              <Title level={3} className="font-android !font-normal text-yellow-principal text-center !text-xl">STEVE RUPPERT</Title>
              <div className="font-android !font-normal text-gray-300 text-sm mb-4">ESTIMATOR</div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Leadership Team Section */}
      {/* <section className="w-full bg-black py-16">
        <div className="container mx-auto px-4">
          <Title level={2} className="font-android !font-normal text-yellow-principal text-center">OUR LEADERSHIP TEAM</Title>
          <Paragraph className="font-barlow text-gray-300 text-xl text-center max-w-2xl mx-auto !mb-12">
            Meet the experienced professionals who lead our company and ensure we deliver excellence on every project.
          </Paragraph>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6"> */}
            {/* Nate Ruppert Card */}
            {/* <div className="bg-second-black-carbon p-6">
              <div className="flex justify-center mb-4">
                <div className="bg-gray-600 w-32 h-32 flex items-center justify-center">
                  <span className="font-android text-gray-400">Photo</span>
                </div>
              </div>
              <Title level={4} className="font-android !font-normal text-yellow-principal text-center mb-1">NATE RUPPERT</Title>
              <div className="text-center text-gray-300 mb-4 font-android">FOUNDER & CEO</div>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                With over 20 years of experience in the construction industry, Nate founded Ruppert Inc. with a vision to create a company known for quality, integrity, and exceptional service.
              </Paragraph>
            </div> */}
            
            {/* Tim Ruppert Card */}
            {/* <div className="bg-second-black-carbon p-6">
              <div className="flex justify-center mb-4">
                <div className="bg-gray-600 w-32 h-32 flex items-center justify-center">
                  <span className="font-android text-gray-400">Photo</span>
                </div>
              </div>
              <Title level={4} className="font-android !font-normal text-yellow-principal text-center mb-1">TIM RUPPERT</Title>
              <div className="text-center text-gray-300 mb-4 font-android">CO-FOUNDER & BUSINESS MANAGER</div>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                Tim oversees the office operations, fabrication and maintenance, ensuring that each job is completed to the highest standards of quality, safety, and efficiency.
              </Paragraph>
            </div> */}
            
            {/* Steve Ruppert Card */}
            {/* <div className="bg-second-black-carbon p-6">
              <div className="flex justify-center mb-4">
                <div className="bg-gray-600 w-32 h-32 flex items-center justify-center">
                  <span className="font-android text-gray-400">Photo</span>
                </div>
              </div>
              <Title level={4} className="font-android !font-normal text-yellow-principal text-center mb-1">STEVE RUPPERT</Title>
              <div className="text-center text-gray-300 mb-4 font-android">ESTIMATOR</div>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                Steve provides accurate project estimates and ensuring that clients receive fair and competitive pricing.
              </Paragraph>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Equipment Section */}
      {/* <section className="w-full bg-first-dark-gray py-16">
        <div className="container mx-auto px-4">
          <Title level={2} className="font-android !font-normal text-yellow-principal text-center !mb-8">OUR EQUIPMENT</Title>
          
          <div className="max-w-4xl mx-auto mb-12">
            <Paragraph className="font-barlow text-base text-gray-300 text-justify">
              Our fleet includes over 30 pieces of heavy equipment, purpose-built for precision and power on any excavation site. From large-scale earthmoving to fine grading, we have the right machine for the job.
            </Paragraph>
            
            <Paragraph className="font-barlow text-base text-gray-300 text-justify">
              Our lineup features:
            </Paragraph>
            
            <ul className="font-barlow text-base text-gray-300 ml-6 !mb-4">
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> Excavators
              </li>
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> Dozers
              </li>
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> Graders
              </li>
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> Skid Steers & Loaders
              </li>
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> Backhoes
              </li>
              <li className="flex items-center gap-2 mb-2">
                <span className="text-yellow-principal">•</span> And more specialized machinery to meet unique project needs
              </li>
            </ul>
            
            <Paragraph className="font-barlow text-base text-gray-300 text-justify">
              Supported by a fleet of 11 trucks and semis, we're ready to mobilize quickly and deliver results.
            </Paragraph>
          </div>
          
          <div className="flex justify-center">
            <img 
              src="/assets/images/our-equipments.png" 
              alt="Ruppert Excavator" 
              className="w-full max-w-[1200px] h-full object-cover"
            />
          </div>
        </div>
      </section> */}
      
      {/* Mission & Values */}
      {/* <section className="bg-second-black-carbon w-full py-16">
        <div className="container mx-auto px-4 text-center">
          <Title level={2} className="font-android !font-normal text-yellow-principal mb-6">OUR MISSION & VALUES</Title>
          <Paragraph className="font-barlow text-gray-300 text-center max-w-3xl mx-auto mb-12">
            At Ruppert Inc., we're guided by a clear mission and a strong set of core values that define who we are and how we work.
          </Paragraph>
           */}
          {/* Mission Subsection */}
          {/* <div className="bg-black p-8 mb-16 max-w-6xl mx-auto mt-12">
            <Title level={3} className="font-android !font-normal text-yellow-principal text-justify mb-4">OUR MISSION</Title>
            <Paragraph className="font-barlow text-gray-300 text-justify">
              To deliver exceptional excavation and construction services that exceed client expectations, while maintaining the highest standards of safety, quality, and environmental responsibility.
            </Paragraph>
          </div>
           */}
          {/* Values Grid */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 max-w-6xl mx-auto"> */}
            {/* Quality */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">QUALITY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                We take pride in delivering exceptional quality in every aspect of our work, from the smallest details to the overall project execution.
              </Paragraph>
            </div> */}
            
            {/* Integrity */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">INTEGRITY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                We conduct our business with honesty, transparency, and ethical practices, building trust with our clients and partners.
              </Paragraph>
            </div> */}
            
            {/* Safety */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">SAFETY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                The safety of our team, clients, and the public is paramount in everything we do, with strict protocols and ongoing training.
              </Paragraph>
            </div> */}
            
            {/* Innovation */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">INNOVATION</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                We continuously seek better, more efficient ways to deliver our services, embracing new technologies and methodologies.
              </Paragraph>
            </div>
             */}
            {/* Reliability */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">RELIABILITY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                Our clients can count on us to deliver on our promises, meet deadlines, and be responsive to their needs throughout the project.
              </Paragraph>
            </div> */}
            
            {/* Environmental Responsibility */}
            {/* <div className="bg-zinc-900 flex-col p-8">
              <div className="w-16 h-16 flex">
                <CheckCircleOutlined className="text-yellow-principal text-2xl" />
              </div>
              <Title level={4} className="font-android !font-normal !text-white text-left">ENVIRONMENTAL RESPONSIBILITY</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                We are committed to minimizing our environmental impact and implementing sustainable practices in our operations.
              </Paragraph>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Safety & Certifications */}
      <section className="w-full bg-first-dark-gray py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Left Column - Text and Certifications */}
            <div>
              <Title level={2} className="font-android !font-normal text-yellow-principal !mb-6">SAFETY & CERTIFICATIONS</Title>
              <Paragraph className="font-barlow text-gray-300 text-justify">
                At Ruppert Inc., safety is our top priority. We maintain rigorous safety standards and
                protocols to ensure the wellbeing of our team, our clients, and the public.
              </Paragraph>
              <Paragraph className="font-barlow text-gray-300 text-justify !mb-8">
                Our team members are trained in the latest safety practices and hold various
                industry certifications, ensuring that all work is performed to the highest standards
                of quality and safety.
              </Paragraph>
              
              {/* Certifications List */}
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <CheckCircleOutlined className="text-yellow-principal text-lg" />
                  <span className="font-barlow text-gray-300">Fully Licensed and Insured</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircleOutlined className="text-yellow-principal text-lg" />
                  <span className="font-barlow text-gray-300">Regular Safety Training Programs</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircleOutlined className="text-yellow-principal text-lg" />
                  <span className="font-barlow text-gray-300">Impeccable Safety Record</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircleOutlined className="text-yellow-principal text-lg" />
                  <span className="font-barlow text-gray-300">Environmental Compliance</span>
                </div>
              </div>
            </div>
            
            {/* Right Column - Quote Box */}
            <div className="bg-zinc-800 p-8 h-full">
              <div className="h-full flex flex-col justify-center items-center">
                <Title level={3} className="font-android !font-normal text-yellow-principal text-center mb-6">OUR SAFETY PROMISE</Title>
                <Paragraph className="font-barlow text-gray-300 text-center mb-8">
                  "We are committed to maintaining the highest standards of safety on every project, protecting our team, our clients, and the environment."
                </Paragraph>
                <div className="w-full">
                  <p className="font-barlow text-yellow-principal italic text-center">- Ruppert Inc. Leadership Team</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}; 